import { NavLink } from 'react-router-dom';

interface TabProps {
  to: string;
  label: string;
  icon: React.ReactNode;
}

function Tab({ to, label, icon }: TabProps) {
  return (
    <NavLink
      to={to}
      end={to === '/'}
      className={({ isActive }) =>
        `flex-1 flex flex-col items-center justify-center gap-1 py-2 transition-colors ${
          isActive ? 'text-accent' : 'text-text-dim hover:text-text-soft'
        }`
      }
    >
      {({ isActive }) => (
        <>
          <span className="relative">
            {icon}
            {isActive && (
              <span
                className="absolute -top-1.5 left-1/2 -translate-x-1/2 w-1 h-1 rounded-full"
                style={{ background: 'var(--accent)' }}
              />
            )}
          </span>
          <span className="text-[11px] font-medium tracking-wide">{label}</span>
        </>
      )}
    </NavLink>
  );
}

export default function NavBar() {
  return (
    <nav
      className="fixed bottom-0 left-0 right-0 z-40 backdrop-blur-lg"
      style={{
        background: 'rgba(10, 13, 18, 0.85)',
        borderTop: '1px solid var(--border)',
        paddingBottom: 'var(--safe-bottom)',
      }}
    >
      <div className="max-w-md mx-auto flex">
        <Tab
          to="/"
          label="Collection"
          icon={
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
              <rect x="3" y="4" width="7" height="7" rx="1.5" stroke="currentColor" strokeWidth="1.8" />
              <rect x="14" y="4" width="7" height="7" rx="1.5" stroke="currentColor" strokeWidth="1.8" />
              <rect x="3" y="14" width="7" height="7" rx="1.5" stroke="currentColor" strokeWidth="1.8" />
              <rect x="14" y="14" width="7" height="7" rx="1.5" stroke="currentColor" strokeWidth="1.8" />
            </svg>
          }
        />
        <Tab
          to="/add"
          label="Add"
          icon={
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
              <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.8" />
              <path d="M12 8v8M8 12h8" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
            </svg>
          }
        />
        <Tab
          to="/me"
          label="Me"
          icon={
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
              <circle cx="12" cy="8" r="4" stroke="currentColor" strokeWidth="1.8" />
              <path d="M4 21c0-4.4 3.6-8 8-8s8 3.6 8 8" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
            </svg>
          }
        />
      </div>
    </nav>
  );
}
